<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>小睿智能筛查管家</el-breadcrumb-item>
      <el-breadcrumb-item>门店</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.storetype" placeholder="请选择门店类型" class="select" style="width: 150px;">
              <el-option label="请选择门店类型" value="-1"></el-option>
              <el-option label="直营店" value="1"></el-option>
              <el-option label="加盟店" value="2"></el-option>
              <el-option label="合作店" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.phone" @keyup.enter.native="clicksearch" placeholder="请输入预约电话" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Name" label="门店名称" min-width="10%"></el-table-column>
          <el-table-column prop="Lat" label="纬度" min-width="10%"></el-table-column>
          <el-table-column prop="Lng" label="经度" min-width="10%"></el-table-column>
          <el-table-column prop="Storetypes" label="门店类型" min-width="10%"></el-table-column>
          <el-table-column prop="Phone" label="预约电话" min-width="10%"></el-table-column>
          <el-table-column prop="Businesshours" label="营业时间" min-width="10%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="10%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="10%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickedit(scope.row)">编辑</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <el-form-item label="门店名称" class="addAdminForm">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="纬度Latitude" class="addAdminForm">
          <el-input v-model="addForm.lat"></el-input>
        </el-form-item>
        <el-form-item label="经度Longtitude" class="addAdminForm">
          <el-input v-model="addForm.lng"></el-input>
        </el-form-item>
        <el-form-item label="门店类型" class="addAdminForm">
          <el-select v-model="addForm.storetype" placeholder="请选择门店类型" class="select" style="width: 150px;">
            <el-option label="请选择门店类型" value="-1"></el-option>
            <el-option label="直营店" value="1"></el-option>
            <el-option label="加盟店" value="2"></el-option>
            <el-option label="合作店" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预约电话" class="addAdminForm">
          <el-input v-model="addForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="营业时间" class="addAdminForm">
          <el-input v-model="addForm.businesshours"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>

    <!-- 编辑 start -->
    <el-tab-pane label="编辑" name="three">
      <el-form :model="editForm" ref="editFormRef" label-width="170px">
        <el-form-item label="门店名称" class="addAdminForm">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="纬度Latitude" class="addAdminForm">
          <el-input v-model="editForm.lat"></el-input>
        </el-form-item>
        <el-form-item label="经度Longtitude" class="addAdminForm">
          <el-input v-model="editForm.lng"></el-input>
        </el-form-item>
        <el-form-item label="门店类型" class="addAdminForm">
          <el-select v-model="editForm.storetype" placeholder="请选择门店类型" class="select" style="width: 150px;">
            <el-option label="请选择门店类型" value="-1"></el-option>
            <el-option label="直营店" value="1"></el-option>
            <el-option label="加盟店" value="2"></el-option>
            <el-option label="合作店" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预约电话" class="addAdminForm">
          <el-input v-model="editForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="营业时间" class="addAdminForm">
          <el-input v-model="editForm.businesshours"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveedit">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>

  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyMiniappshaichaStore',
  data () {
    return {
      activeName: 'first',
      addForm: {
        name: '',
        lat: '',
        lng: '',
        storetype: '1',
        phone: '',
        businesshours: ''
      },
      editForm: {
        id: '',
        name: '',
        lat: '',
        lng: '',
        storetype: '1',
        phone: '',
        businesshours: ''
      },
      // 查询
      keywords: {
        name: '',
        storetype: '-1',
        phone: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      SubRule_Miniappshaicha_SetWxuserIdentity: false
    }
  },
  mounted () {
    this.apiGetMiniappShaichaStoreNum()
    this.apiGetMiniappShaichaStoreList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    clickadd () {
      this.apiAddMiniappShaichaStore()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickedit (row) {
      this.editForm.id = row.Id
      this.editForm.name = row.Name
      this.editForm.lat = row.Lat
      this.editForm.lng = row.Lng
      this.editForm.storetype = row.Storetype.toString()
      this.editForm.phone = row.Phone
      this.editForm.businesshours = row.Businesshours
      this.activeName = 'three'
    },
    saveedit () {
      this.apiEditMiniappShaichaStore()
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelMiniappShaichaStore(row.Id)
      })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetMiniappShaichaStoreNum()
      this.apiGetMiniappShaichaStoreList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetMiniappShaichaStoreList()
    },
    apiGetMiniappShaichaStoreNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.keywords.name,
        storetype: that.keywords.storetype,
        phone: that.keywords.phone
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMiniappShaichaStoreNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetMiniappShaichaStoreList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        name: that.keywords.name,
        storetype: that.keywords.storetype,
        phone: that.keywords.phone
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMiniappShaichaStoreList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddMiniappShaichaStore: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.addForm.name,
        lat: that.addForm.lat,
        lng: that.addForm.lng,
        storetype: that.addForm.storetype,
        phone: that.addForm.phone,
        businesshours: that.addForm.businesshours
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddMiniappShaichaStore, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetMiniappShaichaStoreNum()
            that.apiGetMiniappShaichaStoreList()

            // 清空添加
            that.addForm.name = ''
            that.addForm.lat = ''
            that.addForm.lng = ''
            that.addForm.storetype = '1'
            that.addForm.phone = ''
            that.addForm.businesshours = ''
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditMiniappShaichaStore: function (id, identity) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editForm.id,
        name: that.editForm.name,
        lat: that.editForm.lat,
        lng: that.editForm.lng,
        storetype: that.editForm.storetype,
        phone: that.editForm.phone,
        businesshours: that.editForm.businesshours
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditMiniappShaichaStore, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetMiniappShaichaStoreNum()
            that.apiGetMiniappShaichaStoreList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelMiniappShaichaStore: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelMiniappShaichaStore, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetMiniappShaichaStoreNum()
            that.apiGetMiniappShaichaStoreList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
